import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListaDocDias } from 'src/app/shared/models/lista-docs-dias.model';
import { ListaDocsDigitalizadosUser } from 'src/app/models/ListaDocsDigitalizadosUser';
import { ListaDocsPendientes } from 'src/app/models/ListaDocsPendientes';
import { ObjetoTrazadoDocs, detalleObjetoTrazado } from '../../modules/pages/stats/trazadoEstadoDocumentos/objetoTrazado';
import { ObjetoAutomaticas } from 'src/app/models/objetoAutomaticas';
import { ObjetoListadoDatosDocsSubidosPrinc } from 'src/app/models/ObjetoListadoDatosDocsSubidosPrinc';
import { ListadoSecunTercerosTotalizados } from 'src/app/models/ListadoSecunTercerosTotalizados';
import { AuthService } from 'src/app/core/services/auth.service';
import { ListaDocsSupervisadosUser } from 'src/app/models/ListaDocsSupervisadosUser';



@Injectable({
  providedIn: 'root'
})
export class StatsService {
  private storageKey = 'sdmInvoicerCurrentUser';

  constructor(
    private http: HttpClient,
    private authServices: AuthService
  ) { }

  private GetQuery(query: string): any {

    const url = `${environment.apiUri}api/${query}`;

    return this.http.get<any>(url);
  }

  public ObtenerListadoDocDia(user: string): Observable<ListaDocDias[]> {

    if (user == null) {
      user = "";
    }

    user = user.trim();

    return this.GetQuery(`stats/obtenerListadoDocDia/${user}`);
  }

  public ObtenerDatosDocsDigitalizadosPorUser(fechaInicial: number, fechaFinal: number, horaDesde: number, horaHasta: number): Observable<ListaDocsDigitalizadosUser[]> {
    var usuario = JSON.parse(localStorage.getItem(this.storageKey));
    var grupo: number = 0;
    if (usuario.grupo != null) {
      grupo = usuario.grupo;
    }

    return this.GetQuery(`stats/obtenerDatosDocsDigitalizadosPorUser/${fechaInicial}/${fechaFinal}/${grupo}/${horaDesde}/${horaHasta}`);
  }

  public ObtenerDatosDocsSupervisadosPorUser(fechaInicial: number, fechaFinal: number): Observable<ListaDocsSupervisadosUser[]> {
    var usuario = JSON.parse(localStorage.getItem(this.storageKey));
    var grupo: number = 0;
    if (usuario.grupo != null) {
      grupo = usuario.grupo;
    }

    return this.GetQuery(`stats/obtenerDatosDocsSupervisadosPorUser/${fechaInicial}/${fechaFinal}/${grupo}`);
  }

  public ObtenerListadoDocumentosPendientes(): Observable<ListaDocsPendientes[]> {

    return this.GetQuery(`stats/obtenerListadoDocumentosPendientes`);
  }

  public ObtenerListadoDatosGlobales(): Observable<number[]> {

    return this.GetQuery(`stats/obtenerListadoDocumentosGLOBAL`);
  }

  public obtenerListadoDocumentosPendientesPRIN(): Observable<any[]> {

    return this.GetQuery(`stats/obtenerListadoDocumentosPendientesPRIN`);
  }

  public obtenerListadoNumFactNIF(nif: string): Observable<any[]> {

    return this.GetQuery(`stats/obtenerListadoNumFactNIF/${nif}`);
  }

  public obtenerListadoNumeroDocumentosNifSecundario(principal: string, secundario: string): Observable<any[]> {

    return this.GetQuery(`stats/obtenerListadoSecundariosUsosNIF/${principal}/${secundario}`);
  }

  public ObtenerDocumentosSubidosPorDias(fechaInicial: number, fechaFinal: number): Observable<any[]> {

    return this.GetQuery(`stats/obtenerDocumentosSubidosPorDias/${fechaInicial}/${fechaFinal}`);
  }

  public obtenerTrazadoEstadoDocumentos(idDoc: number, fecha: number, secundario: string, principal: string): Observable<ObjetoTrazadoDocs[]> {


    return this.GetQuery(`stats/ObtenerTrazadoDocumentos/${idDoc}/${fecha}/${secundario}/${principal}`);
  }

  public obtenerDetalleTrazadoDocumentos(idDoc: number): Observable<detalleObjetoTrazado[]> {

    return this.GetQuery(`stats/ObtenerDetalleTrazadoDocumentos/${idDoc}`);
  }

  public obtenerDatosFacturasProcesadasRobot(idDoc: number, fecha: number, secundario: string, principal: string): Observable<ObjetoAutomaticas[]> {

    return this.GetQuery(`stats/ObtenerDatosFacturasProcesadasRobot/${idDoc}/${fecha}/${secundario}/${principal}`);
  }

  public ObtenerListadoDatosDocsSubidosPrinc(principal: string, secundario: string, fechaInicial: number, fechaFinal: number): Observable<ObjetoListadoDatosDocsSubidosPrinc[]> {

    return this.GetQuery(`stats/ListadoDatosDocumentosSubidosPrincipal/${principal}/${secundario}/${fechaInicial}/${fechaFinal}`);
  }

  public cargarPreviewDoc(documento: ObjetoAutomaticas): Observable<ObjetoAutomaticas> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });
    let ruta: string = `${environment.apiUri}api/stats/CargarPreviewDoc`;

    return this.http.post<ObjetoAutomaticas>(ruta, documento, { headers: header });
  }

  public ObtenerListadoSecunTercerosTotal(fechaInicial: number, fechaFinal: number): Observable<ListadoSecunTercerosTotalizados[]> {

    return this.GetQuery(`stats/obtenerListadoSecunTercerosTotal/${fechaInicial}/${fechaFinal}`);
  }

  public generarArchivoExcelTiempos(listado: any, esRevision: boolean): Observable<any> {

    var objeto: any = {
      listadoProc: (esRevision == true) ? [] : listado,
      listadoRev: (esRevision == true) ? listado : [],
      esRevision: esRevision
    };

    let header = new HttpHeaders({
      'content-type': 'application/json',
    });

    let ruta: string = `${environment.apiUri}api/stats/generarArchivoExcelTiempos`;

    return this.http.post<any>(ruta, objeto, { headers: header, responseType: 'blob' as 'json' });
  }

  public generarExcelDocProcSubidosPrinc(objeto: any): Observable<any> {

    let header = new HttpHeaders({
      'content-type': 'application/json',
    });

    let ruta: string = `${environment.apiUri}api/stats/generarExcelDocsProcesadosPorPrin`;
    //let ruta: string = `https://localhost:44326/api/stats/generarExcelDocsProcesadosPorPrin`;

    return this.http.post<any>(ruta, objeto, { headers: header, responseType: 'blob' as 'json' });
  }

  public generarExcelDocsPendientes(): Observable<any> {

    let header = new HttpHeaders({
      'content-type': 'application/json',
    });

    var storageUser = JSON.parse(localStorage.getItem(this.storageKey));
    var usuariosExcluir: string = (storageUser.ignorarCliente != null && storageUser.ignorarCliente != undefined && storageUser.ignorarCliente != "" && storageUser.ignorarCliente != " ") ? storageUser.ignorarCliente : "vacio";

    let ruta: string = `${environment.apiUri}api/stats/generarExcelDocsPendientes/${usuariosExcluir}`;

    return this.http.get<any>(ruta, { headers: header, responseType: 'blob' as 'json' });
  }

  public ObtenerstatsMultifactura(fechaIni: number, fechaFin: number, principal: string, secundario: string, numeroInforme: number): Observable<any> {

    return this.GetQuery(`stats/statsMultifactura/${fechaIni}/${fechaFin}/${principal}/${secundario}/${numeroInforme}`);
  }

}
